<template>
    <div class="fixed-wrapper" :style="heightStyles">
        <div class="ticker-wrap" :style="[themeStyles.tickerWrap, heightStyles]">
            <div ref="ticker" class="ticker" :style="tickerStyle">
                <div v-for="(article, index) in articles"
                     :key="index"
                     class="ticker__item"
                     :style="{ fontSize: fontSize }">
                    <span class="badge badge-danger" :style="{ backgroundColor: article.color }">
                        {{ article.source }}
                    </span>
                    &nbsp;{{ article.article }}&nbsp;&nbsp;&nbsp;
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                articles: [],
                heightStyles: {},
                fontSize: "2.5rem",
                tickerStyle: {},
                themeStyles: { tickerWrap: {} },
                reloadInterval: null
            };
        },
        methods: {
            async getTickerTapeItems() {
                try {
                    console.log("Call to get ticker items");

                    const result = await this.$http.get("digitalNoticeBoard/ticker-tape");
                    this.articles = result.data;
                    this.$nextTick(() => this.updateAnimation());
                } catch (e) {
                    console.error("Ticker load failed", e);
                }
            },
            setTickerHeight() {
                const h = this.$kmsTheme?.tickerHeight;
                if (h) {
                    const numeric = parseFloat(h);
                    this.heightStyles = { height: h };
                    this.fontSize = `${numeric / 2}rem`;
                }
                if (this.$kmsTheme?.styles?.tickerWrap) {
                    this.themeStyles.tickerWrap = this.$kmsTheme.styles.tickerWrap;
                }
            },
            updateAnimation() {
                const ticker = this.$refs.ticker;
                if (ticker) {
                    const totalWidth = ticker.scrollWidth;
                    const speed = this.$kmsTheme?.tickerSpeed || 100; // pixels per second
                    const duration = totalWidth / speed;
                    this.tickerStyle = {
                        animation: `scroll-left ${duration}s linear infinite`
                    };
                }
            }
        },
        async created() {
            this.setTickerHeight();
            await this.getTickerTapeItems();
            this.reloadInterval = setInterval(this.getTickerTapeItems, 180000); // Every 3 minutes manually update 
        },
        mounted() {
            this.$noticeBoardHub?.on('ReloadTickerItems', this.getTickerTapeItems);
        },
        beforeDestroy() {
            clearInterval(this.reloadInterval);
            this.$noticeBoardHub?.off('ReloadTickerItems', this.getTickerTapeItems);
        }
    };
</script>

<style>
    .fixed-wrapper {
        height: 4rem;
    }

    .ticker-wrap {
        position: fixed;
        bottom: 0;
        width: 100%;
        overflow: hidden;
        background-color: #777;
        padding-left: 100%;
    }

    .ticker {
        display: inline-block;
        white-space: nowrap;
        padding-right: 100%;
    }

    .ticker__item {
        display: inline-block;
        padding: 0 2rem;
        color: #fff;
        padding-top: 10px;
    }

    .badge-danger {
        display: inline-block;
        padding: .25em .4em;
        font-size: 75%;
        font-weight: 700;
        line-height: 1;
        white-space: nowrap;
        vertical-align: baseline;
        border-radius: .25rem;
        color: #fff;
    }

    @keyframes scroll-left {
        0% {
            transform: translateX(0);
        }

        100% {
            transform: translateX(-100%);
        }
    }

    @media only screen and (min-width: 1000px) and (orientation:portrait), only screen and (min-width:1500px) and (orientation:landscape) {
        .fixed-wrapper,
        .ticker-wrap {
            height: 5rem;
        }

        .ticker__item {
            font-size: 1.5rem;
        }

        .badge-danger {
            padding: .31em .4em;
        }
    }
</style>
